import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  AccordionComponent,
  AccordionItemComponent,
  EntityDetailLayoutComponent,
  ErrorStateComponent,
  FIELD_PERMISSION_CHECKER,
  FormField,
  Input,
  LoadingStateComponent,
  PageActionsDirective,
  ProfileSummaryCardComponent,
  ZagButton,
  ZagIcon,
} from '@zag/ui';
import { WebhookEditFacade, EVENT_TYPES } from './webhook-edit.facade';

@Component({
  selector: 'zag-webhook-edit',
  templateUrl: './webhook-edit.component.html',
  styleUrl: './webhook-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [WebhookEditFacade],
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    EntityDetailLayoutComponent,
    ProfileSummaryCardComponent,
    AccordionComponent,
    AccordionItemComponent,
    FormField,
    Input,
    ZagButton,
    ZagIcon,
    LoadingStateComponent,
    ErrorStateComponent,
    PageActionsDirective,
  ],
})
export class WebhookEditComponent {
  protected readonly facade = inject(WebhookEditFacade);
  private readonly permissions = inject(FIELD_PERMISSION_CHECKER);

  protected readonly eventTypes = EVENT_TYPES;

  protected readonly canManage = computed(() => this.permissions.hasPermission('webhooks:manage'));
  protected readonly canReadDeliveries = computed(() => this.permissions.hasPermission('webhooks:deliveries:read'));

  protected readonly saveDisabled = computed(() => {
    if (this.facade.isSaving()) return true;
    this.facade.formValues();
    if (this.facade.form.invalid) return true;
    if (this.facade.selectedEventTypes().size === 0) return true;
    if (!this.canManage()) return true;
    return false;
  });

  protected onQuickAction(action: { id: string }): void {
    if (action.id === 'test') {
      this.facade.onTestDelivery();
    }
  }

  protected onDangerAction(action: { id: string }): void {
    if (action.id === 'delete') {
      this.facade.onDelete();
    }
  }
}
